export default {
  loading: false,
  rootData: {},
  selected: {
    id: 1,
    name: 'Universität Leipzig'
  },
  open: [],
  branch: {}
}



// WEBPACK FOOTER //
// ./src/store/modules/tree/state.js